var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DrawerStyles } from "@/components/styles/DrawerStyles";
import ElectionHeader from "@/components/ElectionHeader";
import { useTranslation } from "react-i18next";
import { Box, Drawer } from "@mui/material";
import { ImportScreen } from "./ImportScreen";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
export var ImportDataDrawer = function (_a) {
    var _b = _a.open, open = _b === void 0 ? null : _b, _c = _a.closeDrawer, closeDrawer = _c === void 0 ? null : _c, title = _a.title, subtitle = _a.subtitle, paragraph = _a.paragraph, _d = _a.doImport, doImport = _d === void 0 ? null : _d, disableImport = _a.disableImport, _e = _a.uploadCallback, uploadCallback = _e === void 0 ? null : _e, errors = _a.errors;
    var t = useTranslation().t;
    var _f = useCreateElectionEventStore(), importDrawer = _f.importDrawer, closeImportDrawer = _f.closeImportDrawer, handleImportElectionEvent = _f.handleImportElectionEvent, doUploadCallback = _f.uploadCallback, importErrors = _f.errors;
    return (_jsx(_Fragment, { children: _jsx(Drawer, __assign({ anchor: "right", open: open || importDrawer, onClose: function () {
                closeDrawer ? closeDrawer() : closeImportDrawer();
            }, PaperProps: {
                sx: { width: "30%" },
            } }, { children: _jsxs(Box, __assign({ sx: { padding: "16px" } }, { children: [_jsx(ElectionHeader, { title: title, subtitle: subtitle }), _jsx(DrawerStyles.Wrapper, { children: _jsxs(_Fragment, { children: [_jsx(DrawerStyles.SubTitle, { children: t(paragraph) }), _jsx(ImportScreen, { refresh: "electionEventScreen.import.voters", doCancel: function () {
                                        closeDrawer ? closeDrawer() : closeImportDrawer();
                                    }, doImport: doImport || handleImportElectionEvent, disableImport: disableImport || !!importErrors, uploadCallback: uploadCallback ? uploadCallback : doUploadCallback, errors: errors || importErrors })] }) })] })) })) }));
};
